import request from "@/config/utils/request";

//登录
export function loginSup(data) {
  return request({
    url: "/apis/sp/smc/users/signup/loginSup",
    method: "post",
    data
  });
}
//秘钥
export function createLoginKey(data) {
  return request({
    url: "/apis/sp/smc/users/signup/createLoginKey",
    method: "post",
    data
  });
}
// 发送验证码
export function mobile(data) {
  return request({
    url: "/apis/sp/smc/users/signup/mobile",
    method: "post",
    data
  });
}
